/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Redirect, useLocation } from "react-router"
import { RootState } from "./globalStore/rootreducer"
import AuthService from "./service/auth/authService"

const Auth = (props: any) => {
  const location = useLocation()
  const token = useSelector((root: RootState) => root.user.Token)
  const [isLoggedIn, setIsLoggedIn] = useState(token != null && token !== "")

  useEffect(() => {
    if (location.pathname !== "/" && location.pathname !== "/login") {
      new AuthService()
        .test()
        .then(() => {
          setIsLoggedIn(true)
        })
        .catch((error) => {
          setIsLoggedIn(false)
        })
    }
  }, [location.pathname])

  return isLoggedIn ? props.children : <Redirect to={"/login"} />
}
export default Auth
